module.exports = __webpack_public_path__ + "img/取消提醒.c8ef30f3.svg";